import { ReactComponent as PizzaLogo } from 'assets/logos/404.svg';

export const NotFound = () => {
  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="text-gray-500 text-xs md:text-lg xl:text-3xl font-bold text-center">
          THIS PAGE MUST BE PLAYING HIDE AND SEEK
        </div>
        <div className="text-black text-4xl md:text-7xl xl:text-8xl flex items-center justify-center font-bold gap-2 relative flex-wrap">
          THAT&apos;S AN <div className="text-primary">ERROR</div>
          <PizzaLogo className="absolute -bottom-6 md:-bottom-8 xl:-bottom-10 left-1/2 -translate-x-1/2 h-[50px] md:h-[80px] xl:h-[110px] w-auto" />
        </div>
        <a
          href="/menu"
          className="bg-primary flex items-center justify-center rounded-xl w-[120px] md:w-[140px] xl:w-[150px] h-[50px] xl:h-[60px] text-base font-semibold mt-[30px] md:mt-[50px]"
        >
          <span className="text-white">GO BACK</span>
        </a>
      </div>
    </div>
  );
};
